import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { FuncionarioDependenciaModel } from 'src/app/models/funcionarioDependencia.model';
import { VisitaModel } from 'src/app/models/visita.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
declare var $: any;

@Component({
  selector: 'app-listar-dependencias-funcionarios',
  templateUrl: './listar-dependencias-funcionarios.component.html',
  styleUrls: ['./listar-dependencias-funcionarios.component.scss']
})
export class ListarDependenciasFuncionariosComponent implements OnInit {

  public consultaDependencia: any;
  public visitaModel: VisitaModel;
  public funcionarios: FuncionarioDependenciaModel[];
  public listaDependencias: any;
  public sedes: any;

  constructor(private alertService: AlertService, private modalService: NgbModal
    , private activeModal: NgbActiveModal, private global: GlobalService
    , private urlService: UrlService, private spinner: NgxSpinnerService) {

    this.visitaModel = new VisitaModel(null, null, null, null, null, false, null, null, null, null);

  }

  ngOnInit() {
    this.getSedes();
    this.getDependencias();
  }

  /**
 * @author klagos
 * método para consumir el dominio de dependencias
 *  20/12/2019
 */
  getDependencias() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDependencias';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.consultaDependencia = data;
        if (this.visitaModel.dependencia) {
          this.listaDependencias = data;
        }
        this.spinner.hide();
      }, err => {
        // this.cacthException('No es posible Obtener las dependencias');
      }
    );
  }

  // fromero
  // método para consultar los funcionarios por dependencia y sede
  // 29/04/2019
  getFuncionariosDependencia(dependencia) {
    this.visitaModel.dependencia = dependencia.idDependencia;
    if (!isNaN(this.visitaModel.dependencia) && this.visitaModel.dependencia != null) {
      if (this.visitaModel.sede != '' && this.visitaModel.sede) {
        this.spinner.show();
        const serviceProvider = 'ObtenerFuncionario';
        // const pathParams: Array<[number, string]> = null;
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=idDependencia', this.urlService.encodeURI(this.visitaModel.dependencia)]);
        pathParams.push(['sede', this.urlService.encodeURI(this.visitaModel.sede)]);
        let url = this.urlService.getUrl(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_ACCVIS);
        url = url.concat('&orderBy=nombreCompleto$ASC');

        this.global.getGenerico(url).subscribe(
          (data: any[]) => {
            this.funcionarios = data;

            this.spinner.hide();
          }, err => {
            this.cathException('No es posible cargar los funcionarios', err);
          }
        );
      }
    }
  }

  /**
   * Metodo que filtra las dependencias por sede
   * @author klagos@asesoftware.com
   */
  filtrarDependencias() {
    this.listaDependencias = this.consultaDependencia.filter(dep => dep.sede ===
      this.visitaModel.sede);
  }

  // fromero
  // método para consultar las sedes
  // 30/05/2019
  getSedes() {
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.sedes = data;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible cargar las Sedes', err);
      }
    );
  }

  // froero
  // handler de excepción de consumo de servicios
  // 29/04/2019
  cathException(error, err) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }


  fallbackCopyTextToClipboard(text) {

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

  }

  copiar(text) {

    let newVariable: any;

    newVariable = window.navigator;

    if (!newVariable.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    newVariable.clipboard.writeText(text).then(function () {
      console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

}
